<app-loader></app-loader>
<div class="container-fluid addBackground">
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
<app-dialog></app-dialog>
<p-toast [baseZIndex]="5000" position="top-left"></p-toast>
